export var createMuiListOverrides = function () {
    return {
        styleOverrides: {
            root: {
                outline: 0,
            },
        },
    };
};
